export default "__VITE_ASSET__CWgYT5kv__"